import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getScrollParent, smoothScroll } from '@src/public/utils';
import { addReplyUser, replyComment } from '../utils';
import { Store } from '../store';
import styles from './index.css';

const ReplyBtn = ({ subjectId, commentId }) => {
    const store = Store.useContainer();
    const { states, changeStates } = store;
    const { list, topIdList, replyList, docMeta } = states;

    const wrapRef = useRef();

    const insertComment = insertItem => {
        const { rootId } = insertItem;
        const newList = [...list];

        if (rootId === '0') {
            // 一级评论
            const newTopIdList = [...topIdList, insertItem.id];

            newList.unshift(insertItem);

            changeStates({ list: newList, topIdList: newTopIdList });

            smoothScroll(getScrollParent(wrapRef.current), 0);
        } else {
            // 二级评论
            const newReplyList = [insertItem, ...replyList];

            addReplyUser(newReplyList);

            changeStates({ replyList: newReplyList });

            smoothScroll(getScrollParent(wrapRef.current), 0);
        }
    };

    const handleReplyClick = () => {
        replyComment({
            subjectId,
            rootId: commentId || '0',
            pId: commentId || '0',
            docMeta,
            callback: insertComment,
        });
    };

    return (
        <>
            <div className={styles.placeholder}>
                <div className={styles.content} />
            </div>
            <div className={styles.wrap} onClick={handleReplyClick} ref={wrapRef}>
                <div className={styles.content}>我来说两句~</div>
            </div>
        </>
    );
};

ReplyBtn.propTypes = {
    subjectId: PropTypes.string,
    commentId: PropTypes.string,
};

export default errorBoundary(ReplyBtn);
